module.exports = __webpack_public_path__ + "img/icon_animation_waterwheel_default.3bd8d924.svg";